const accessibilityClassName = 'accessibility';

function handleKeyDown(event) {
  if (event.keyCode === 9) {
    document.body.classList.add(accessibilityClassName);
  }
}

function handleMouseDown() {
  document.body.classList.remove(accessibilityClassName);
}

function init() {
  document.addEventListener('keydown', (event) => handleKeyDown(event));
  document.addEventListener('mousedown', () => handleMouseDown());
}

init();



// WEBPACK FOOTER //
// ./scripts/autoload/accessibility.js